export const icons = {
  undo: 'undo',
  redo: 'redo',
  bold: 'bold',
  formatUL: 'bulleted-list',
  clearFormatting: 'clean',
  italic: 'italic',
  formatOLSimple: 'numbered-list',
  textColor: 'text-color',
  underline: 'underline',
  backgroundColor: 'color-highlight',
  insertTable: 'table',
  insertImage: 'image',
  insertLink: 'url',
  spellcheck: 'spell-check',
  tableHeader: 'table-header',
  tableFooter: 'table-footer',
  tableRemove: 'trash-bin',
  tableRows: 'table-row',
  tableColumns: 'table-column',
  tableStyle: 'table-style',
  tableCells: 'table-cell',
  tableCellBackground: 'table-cell-background',
  tableCellVerticalAlign: 'vertical-align',
  tableCellHorizontalAlign: 'alignment',
  imageReplace: 'replace',
  imageCaption: 'image-caption',
  imageRemove: 'trash-bin',
  imageDisplay: 'positioning',
  imageAlign: 'alignment'
};

export const buttonsToTriggerClearFormatting = [
  'bold',
  'italic',
  'underline',
  'fontSize',
  'clearFormatting',
  'undo',
  'redo'
];

export const alignmentIcons = {
  alignLeft: ['f-i', 'f-i-alignment'],
  alignCenter: ['f-i', 'f-i-center-alignment'],
  alignRight: ['f-i', 'f-i-right-alignment'],
  alignJustify: ['f-i', 'f-i-width-alignment']
};

export const fonts = [
  ['Arial, Helvetica, sans-serif', 'Arial'],
  ["'Arial Black', Gadget, sans-serif", 'Arial Black'],
  ["'Calibri', 'Source Sans Pro', sans-serif", 'Calibri'],
  ["'Times New Roman', serif", 'Times New Roman'],
  ['Verdana, sans-serif', 'Verdana'],
  ["Helvetica, 'Noto Sans', sans-serif", 'Helvetica'],
  ['Georgia, serif', 'Georgia'],
  ['Tahoma, sans-serif', 'Tahoma'],
  ["'Comic Sans MS', 'Comic Neue', cursive", 'Comic Sans MS'],
  ["'Courier New', Courier, monospace", 'Courier New'],
  ['Impact, sans-serif', 'Impact'],
  ["'Franklin Gothic Medium', 'Oswald', sans-serif", 'Franklin Gothic Medium'],
  ["'Cambria', 'Merriweather', serif", 'Cambria'],
  ["'Segoe UI', 'Noto Sans', sans-serif", 'Segoe UI'],
  ["'Lucida Sans Unicode', 'Lucida Grande', sans-serif", 'Lucida Sans Unicode'],
  ['Garamond, serif', 'Garamond'],
  ["'Palatino Linotype', Palatino, serif", 'Palatino Linotype'],
  ["Consolas, 'Amaranth', monospace", 'Consolas'],
  ["'Trebuchet MS', Helvetica, sans-serif", 'Trebuchet MS'],
  ["'Futura', 'Montserrat', sans-serif", 'Futura']
];
